import React, { useState } from 'react';
import { useNavigate,useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import './css/ticketcheckout.css'; 
import { API_URL_BASE, URL_BASE } from './config';

function PrivateCheckout() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { eventid } = useParams();
  const { t } = useTranslation();
  const [redirecting, setRedirecting] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "" , group: ""});
  const [paymentMethod, setPaymentMethod] = useState("free");
  const [emailError, setEmailError] = useState('');  
  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  
  // Destructure safely with fallbacks
  const event = state?.event || {};
  const tickets = state?.tickets || [];
  const total = state?.total || 0;
  const processingfee = state?.processingfee || 0;
 
  console.log(event);

  const handleSubmit = async (e) => {
    e.preventDefault();
	
	try {
		if (formData.name && formData.email && formData.group && paymentMethod) {

		  const ticketSkus = tickets.flatMap(ticket => Array(ticket.ticketsold).fill(ticket.ticketsku)).join(',');
		  
		  console.log("Proceeding to payment with:", { formData, paymentMethod, tickets, ticketSkus, total , processingfee });
				  
		  // HANDLE PAYMENT
		  const response = await fetch(API_URL_BASE + '/ticket.json', {
		  			    	method: 'POST',
		  			    	headers: {
		  			      	'Content-Type': 'application/json',
		  			    	},
		  			    	body: JSON.stringify(					{
		  						ticketPurchase : {
									purchase:{
		  								eventid:eventid,
		  								paymentmethod: paymentMethod,
		  								skus: ticketSkus,
		  								total :total,
		  								processingfee: processingfee,
		  								name: formData.name + "," + formData.group,
		  								email:formData.email,
										language: localStorage.getItem("lang") || "en",
										callback: URL_BASE + '/pay/privateconfirmation/' + eventid
										}
		  							}
		  					  })
		  			  	}).then(res => {
						         if (!res.ok) throw new Error('Event not found');
						         return res.json();
						}).then(data => {
							if (data.message && data.message.startsWith("http")) {
							    setRedirecting(true);

							    // Small delay to allow React to render UI
							    setTimeout(() => {
							      window.location.href = data.message;
							    }, 300);
							  }

						});
		} else {
		  alert("Please fill all details and select a payment method.");
		}
	} catch (e) {
		
	}

  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
	if (e.target.name === "email") {
	  // Clear email error as user types
	  if (validateEmail(e.target.value)) {
	    setEmailError("");
	  } else {
	    setEmailError("Please enter a valid email address.");
	  }
	}
  };

  return (
	<div>
	{redirecting && (
	  <div className="payment-processing-overlay">
	    <div className="payment-processing-box">
	      <h2>Redirecting to Payment.... </h2>
	      <p>Please do not refresh or close this page</p>
	      <div className="spinner"></div>
	    </div>
	  </div>
	)}
	
    <div className="ticketcheckout-container">
	  <div className="event-header">
	    <button className="back-button" onClick={() => navigate(-1)}>
	      ← {t("back")}
	    </button>
	    <h1>{t("checkout")}</h1>
	  </div>
	  <form className="checkout-form" onSubmit={handleSubmit}>

      {/* User Info Card */}
      <div className="user-info-card">
        <h2 className="section-title">1. {t("information")}</h2>
        <div className="user-form">


            <input
              type="email"
              name="email"
              placeholder="Email Address"
			  className={emailError ? 'input-error' : ''}
              onChange={handleChange}
              required
            />
			<input
			  type="text"
			  name="name"
			  placeholder={t("childname")}
			  onChange={handleChange}
			  required
			/>	
			<input
			  type="number"
			  name="group"
			  placeholder={t("group")}
			  onChange={handleChange}
			  required
			  min="1"
			  max="8"
			/>					
			{emailError && <p className="error-text">{emailError}</p>}

		</div>
		</div>
		
            {/* Payment Information Card */}
            <div className="payment-card">
              <h2 className="section-title">2. {t("payment")}</h2>
			  {event.type !== 'FREE' ? (
              <div className="payment-options">
                <label className="payment-option">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="ideal"
                    checked={paymentMethod === "ideal"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  />
				  <img  src="/iDEAL_Wero.png" alt="" className="payment-logo"/>
                </label>

                {/*<label className="payment-option">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="paypal"
                    checked={paymentMethod === "paypal"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  />
                  PayPal
                </label>

                <label className="payment-option">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="creditcard"
                    checked={paymentMethod === "creditcard"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  />
                  Credit Card
                </label>*/}
              </div>
			  ) : (
				<div>
					<label className="payment-option">
					  <input
					    type="radio"
					    name="paymentMethod"
					    value="free"
					    checked={paymentMethod === "free"}
					    onChange={(e) => setPaymentMethod(e.target.value)}
					  />
					  FREE
					</label>
				</div>
			  )}
            </div>

			<div className="ticket-form">
			  <button type="submit"  disabled= {!formData.name || !formData.email || !paymentMethod}>{t("confirm")}️</button>
			</div>

		</form>
		
		</div>
		
		<div className='footer'>
		<span >© Processed by Buydeal.EU B.V</span>
		</div>
			
    </div>
	

	
  );
}

export default PrivateCheckout;
